import configuration from '../../../../configuration'
import { request } from '../../../../common/utility/fetch'
import { AppThunk, RootState } from '../../../store'
import {
  getWorkoutsPending,
  getWorkoutsSuccess,
  getWorkoutsFailure,
  WorkoutsJsonResponse,
  WorkoutsJsonSuccessResponse,
} from '.'

const fetchWorkouts = async (
  tagFilters: number[],
  favoriteFilter: boolean,
  hideCompletedFilter: boolean,
  authToken?: string,
  page?: number,
): Promise<WorkoutsJsonResponse> => {
  let params = '?type=ONDEMAND'
  const pageParam = page || 0
  const paginationParams = favoriteFilter
    ? '&page='
    : `&size=${configuration.workoutsPageSize}&page=`
  const baseUrl = configuration.onlinePlatformApi
  const endpoint = '/workout-library/workouts'
  if (tagFilters.length > 0)
    params = params.concat('&tags=', tagFilters.join(','))
  if (favoriteFilter) params = params.concat('&favorite=true')
  if (hideCompletedFilter) params = params.concat('&checkedIn=false')
  params = params.concat(paginationParams, pageParam.toString())
  const method = 'GET'
  const response = await request({
    baseUrl,
    endpoint,
    method,
    authToken,
    params,
  })
  const {
    content,
    number,
    totalPages,
    totalElements,
    error,
  }: WorkoutsJsonResponse = await response.json()
  return response.ok
    ? { content, number, totalElements, totalPages }
    : Promise.reject(new Error(error))
}

export const getWorkouts = (): AppThunk => async (dispatch, getState) => {
  const state = getState() as RootState
  const authToken = state.auth?.user?.auth_token
  const page =
    typeof state.workouts.lastPageFetched === 'undefined'
      ? 0
      : state.workouts.lastPageFetched + 1
  dispatch(getWorkoutsPending(true))
  try {
    const response = await fetchWorkouts(
      state.filters.tagFilters,
      state.filters.favoriteFilter,
      state.filters.hideCompletedFilter,
      authToken,
      page,
    )
    dispatch(getWorkoutsSuccess(response as WorkoutsJsonSuccessResponse))
  } catch (error: any) {
    dispatch(getWorkoutsFailure(error.toString()))
  }
}
